import React from "react";

function AccountDisabledModal({ open, onOkay }) {
  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
      <div
        className="modal fade show d-block"
        style={{ zIndex: 1055 }}
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="mb-4">
                <span
                  className="success-icon mx-auto mb-4"
                  style={{ background: "red" }}
                >
                  <i className="fa fa-exclamation-triangle" aria-hidden="true" />
                </span>
                <h5 className="mb-1">Account Disabled</h5>
                <p className="mb-0">
                  The admin has disabled your account. Please contact admin
                </p>
              </div>
              <div
                className="buttons"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <button
                  type="button"
                  className="btn btn-linear-primary"
                  onClick={onOkay}
                >
                  OKAY
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AccountDisabledModal;
